import React from "react"

import Layout from "../components/common/layout/layout"
import SEO from "../components/common/layout/seo"
import Navigation from "../components/common/navigation/navigation"

import Leaderboard from "../components/sections/leaderboard"
import Footer from "../components/sections/footer"

const LeaderboardPage = () => (
  <Layout>
    <SEO title="Leaderboard" />
    <Navigation />
    <Leaderboard />
    <Footer />
  </Layout>
)

export default LeaderboardPage
